import { render, staticRenderFns } from "./TemplateLayout.vue?vue&type=template&id=400c293b"
import script from "./TemplateLayout.vue?vue&type=script&lang=js"
export * from "./TemplateLayout.vue?vue&type=script&lang=js"
import style0 from "./TemplateLayout.vue?vue&type=style&index=0&id=400c293b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports